import React, { useEffect, useState, useReducer, useContext } from "react"
import newsReducer from "../reducers/newsReducer"
import VicinityContext from "../context/vicinityContext"
import { getNewsData } from "../services/chaperonConnector"

import { NEWS_DEFAULT, NEWS_ERROR } from "../const/strings_en"
import { SESSIONSTORAGE_NEWS } from "../const/storage"
import { consoleLog } from "../utilities/helpers"

export default function NewsTicker() {
    const [reverseAnimation, setReverseAnimation] = useState(false)
    const [isAnimationPaused, setIsAnimationPaused] = useState(false)
    const [newsItems, dispatch] = useReducer(newsReducer, NEWS_DEFAULT)

    let location = useContext(VicinityContext).location
    let countryCode = useContext(VicinityContext).countryCode
    let setNews = useContext(VicinityContext).setNews

    const handleReverse = () => {
        setReverseAnimation((prev) => !prev)
    }

    const handlePause = () => {
        setIsAnimationPaused((prev) => !prev)
    }

    useEffect(() => {
        let cancelled = false
        // consoleLog("Vicinity Data location:", location)
        // TODO: Set a timeout to refresh the news data every NEWS_REFRESH milliseconds
        const newsData = JSON.parse(sessionStorage.getItem(SESSIONSTORAGE_NEWS))
        consoleLog("News data from session storage:", newsData)
        consoleLog("Current country code:", countryCode)
        if (newsData?.[0] && newsData?.[0].country_code === countryCode) {
            consoleLog(`News items from session storage:`, newsData)
            consoleLog(`Country code:`, countryCode)
            setNews(newsData)
            const newsMapped = newsData.map((item, index) => ({
                id: index,
                title: item.title,
                url: item.url,
            }))
            dispatch({ type: "GET_NEWS", news: newsMapped })
            consoleLog("Loaded news items from session storage.")
        } else {
            // A slower response for an earlier country must not replace
            // the current one's news.
            if (countryCode) {
                consoleLog(
                    `Fetching news data for ${countryCode} from Chaperon API.`
                )
                getNewsData(location, countryCode)
                    .then((data) => {
                        if (cancelled) return
                        consoleLog("Fetched news data from API:", data)
                        if (data.length === 0) {
                            consoleLog("No news data available.")
                            dispatch({ type: "GET_NEWS", news: NEWS_ERROR })
                            return
                        }

                        const newsItems = data.map((item, index) => ({
                            id: index,
                            title: item.title,
                            url: item.url,
                        }))
                        dispatch({ type: "GET_NEWS", news: newsItems })
                        sessionStorage.setItem(
                            SESSIONSTORAGE_NEWS,
                            JSON.stringify(data)
                        )
                        setNews(data)
                    })
                    .catch((error) => {
                        if (cancelled) return
                        console.error("Error fetching news data:", error)
                        sessionStorage.removeItem(SESSIONSTORAGE_NEWS)
                        setNews([])
                        dispatch({ type: "GET_NEWS", news: NEWS_ERROR })
                    })
            }
        }
        return () => {
            cancelled = true
        }
    }, [location, countryCode, setNews])

    return (
        <div id="newsTicker" className="bn-breaking-news mb-4 ms-3">
            <div className="bn-label">NEWS</div>
            <div className="enable-animation">
                <div
                    className={`marquee ${
                        reverseAnimation && "marquee--reverse"
                    } ${isAnimationPaused && "marquee--paused"}`}
                    onDoubleClick={handleReverse}
                >
                    <div
                        className="marquee__content"
                        style={{
                            animationDuration: `${
                                (newsItems.length > 1 ? newsItems.length : 4) *
                                10
                            }s`,
                        }}
                    >
                        {newsItems.map((item, index) => (
                            <div className="marquee__item" key={index}>
                                <i className="bi bi-newspaper me-2 text-danger"></i>
                                <div>
                                    <a
                                        href={item.url}
                                        target={item.url ? "_blank" : "_parent"}
                                        rel="noopener noreferrer"
                                    >
                                        {item.title}
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div
                        aria-hidden="true"
                        className="marquee__content"
                        style={{
                            animationDuration: `${
                                (newsItems.length > 1 ? newsItems.length : 4) *
                                10
                            }s`,
                        }}
                    >
                        {newsItems.map((item, index) => (
                            <div className="marquee__item" key={index}>
                                <i className="bi bi-newspaper me-2 text-danger"></i>
                                <div>
                                    <a
                                        href={item.url}
                                        target={item.url ? "_blank" : "_parent"}
                                        rel="noopener noreferrer"
                                    >
                                        {item.title}
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="bn-controls">
                <button onClick={handleReverse}>
                    <div className="bn-arrow bn-prev"></div>
                </button>
                <button onClick={handlePause}>
                    <i
                        className={`bi ${!isAnimationPaused && "bi-pause"} ${
                            isAnimationPaused && "bi-play"
                        }`}
                    ></i>
                </button>
                <button onClick={handleReverse}>
                    <div className="bn-arrow bn-next"></div>
                </button>
            </div>
        </div>
    )
}
